import {NavigationPaths} from '../types/app-types'

export function getNavigationPaths(accountId: string): NavigationPaths {
  const accountPath = getAccountPath(accountId)
  return {
    Account: accountPath,
    AddPaymentAccount: `${accountPath}/add-payment-account`,
    AddSupportRequest: `${accountPath}/add-support-request`,
    Billing: `${accountPath}/billing`,
    Home: '/',
    MakePayment: `${accountPath}/make-payment`,
    MakePaymentResult: `${accountPath}/make-payment-result`,
    PaymentAccounts: `${accountPath}/payment-accounts`,
    PaymentHistory: `${accountPath}/payment-history`,
    SupportRequests: `${accountPath}/support`
  }
}

export function getAccountPath(accountId: string): string {
  return `/account/${accountId}`
}
